import React, { useMemo, useState } from 'react';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import { DefaultModal } from '../../designComponents/modals/ModalComponent';
import { MainButton } from '../../designComponents/buttons/Buttons';
import { buildDatingKickPayload, findDatingKickCounterpartId } from './datingKickPayload';

const DatingChattingDetailModal = ({ visible, onClose = () => {}, chatItem, onSuccess = () => {} }) => {
    const [loadingUserId, setLoadingUserId] = useState(null);

    const users = useMemo(() => {
        if (!chatItem) return [];

        const fromUserId = chatItem.from_id;
        const toUserId = chatItem.to_id;

        return [
            {
                key: 'from',
                id: fromUserId,
                name: chatItem.from_name || '-',
                nickName: chatItem.from_nick_name || '-',
                sex: chatItem.from_sex,
                avail: chatItem.from_avail,
            },
            {
                key: 'to',
                id: toUserId,
                name: chatItem.to_name || '-',
                nickName: chatItem.to_nick_name || '-',
                sex: chatItem.to_sex,
                avail: chatItem.to_avail,
            },
        ];
    }, [chatItem]);

    const reportRows = useMemo(() => {
        if (!chatItem) return [];
        const rows = [];
        if (chatItem.from_reported) {
            rows.push({
                reporter: `${chatItem.to_nick_name || '-'}(${chatItem.to_name || '-'})`,
                reported: `${chatItem.from_nick_name || '-'}(${chatItem.from_name || '-'})`,
                reason: chatItem.from_reported,
            });
        }
        if (chatItem.to_reported) {
            rows.push({
                reporter: `${chatItem.from_nick_name || '-'}(${chatItem.from_name || '-'})`,
                reported: `${chatItem.to_nick_name || '-'}(${chatItem.to_name || '-'})`,
                reason: chatItem.to_reported,
            });
        }
        return rows;
    }, [chatItem]);

    const sexFilter = (sex) => {
        const num = parseInt(sex);
        if (num === 1) return '남';
        if (num === 2) return '여';
        return '-';
    };

    const requestKickUser = async (userId, targetId) => {
        const response = await RefreshCheckApi.patch('/v2/chatting/user/kick', buildDatingKickPayload(userId, targetId));
        if (response?.status >= 200 && response?.status < 300) {
            return true;
        }
        throw new Error('kick fail');
    };

    const onClickKick = (userId) => async () => {
        const targetId = findDatingKickCounterpartId(userId, chatItem);
        if (!chatItem?.id || !userId) {
            alert('채팅/유저 정보가 없어 강퇴할 수 없습니다.');
            return;
        }
        if (!window.confirm('해당 유저를 채팅방에서 내보내시겠습니까?')) {
            return;
        }

        try {
            setLoadingUserId(userId);
            await requestKickUser(userId, targetId);
            alert('유저를 채팅방에서 내보냈습니다.');
            onSuccess();
        } catch (error) {
            console.error('error: ', error);
            alert('강퇴 처리에 실패했습니다. API 경로를 확인해 주세요.');
        } finally {
            setLoadingUserId(null);
        }
    };

    return (
        <DefaultModal
            title="채팅 상세"
            visible={visible}
            onClickClose={onClose}
            onClickBottomClose={onClose}
            closeOn={true}
            bottomBtnOn={true}
            boxStyle={{ width: '780px', maxWidth: '95%' }}
            bodyWidth={55}
        >
            <div style={{ padding: '16px 20px' }}>
                <div style={{ marginBottom: 10, fontSize: 14, fontWeight: 600 }}>채팅방 정보</div>
                <div style={{ marginBottom: 16, fontSize: 13, color: '#555' }}>
                    채팅 ID: {chatItem?.id || '-'} / 상태: {chatItem?.avail_yn === 'N' ? '비활성화' : '활성화'}
                </div>

                <div style={{ marginBottom: 10, fontSize: 14, fontWeight: 600 }}>참여 유저 강퇴</div>
                <div style={{ border: '1px solid #ededed', borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
                    {users.map((user, index) => (
                        <div
                            key={`${user.key}-${user.id || index}`}
                            style={{
                                padding: '12px',
                                borderBottom: index === users.length - 1 ? 0 : '1px solid #f2f2f2',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <div style={{ fontSize: 13, color: '#333' }}>
                                {user.name} / {user.nickName} / {sexFilter(user.sex)} / ID: {user.id || '-'} {!user.avail ? '(이미 나감)' : ''}
                            </div>
                            <MainButton
                                text={!user.id ? '불가' : loadingUserId === user.id ? '처리중' : '강퇴'}
                                onClick={onClickKick(user.id)}
                                style={{ minWidth: 80, opacity: !user.id ? 0.5 : 1 }}
                                fontStyle={{ fontSize: 12 }}
                            />
                        </div>
                    ))}
                </div>

                <div style={{ marginBottom: 10, fontSize: 14, fontWeight: 600 }}>신고 상세 보기</div>
                <div style={{ border: '1px solid #ededed', borderRadius: 8, padding: 12 }}>
                    {reportRows.length === 0 ? (
                        <div style={{ fontSize: 13, color: '#888' }}>신고 내역이 없습니다.</div>
                    ) : (
                        reportRows.map((row, index) => (
                            <div key={`report-${index}`} style={{ marginBottom: index === reportRows.length - 1 ? 0 : 12, fontSize: 13, color: '#333' }}>
                                <div>신고자: {row.reporter}</div>
                                <div>피신고자: {row.reported}</div>
                                <div>사유: {row.reason}</div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </DefaultModal>
    );
};

export default DatingChattingDetailModal;
